import currencies from "@/helpers/constants/currencies";

export const formatPrice = (value, { store, currency } = {}) => {
  let priceCurrency;
  if (currency) {
    priceCurrency = currencies.find(item => item.code === currency);
  } else if (store) {
    priceCurrency = store.getters["services/currency"];
  }
  if (typeof value === "number") {
    let price = new Intl.NumberFormat("ru-RU").format(value);
    return priceCurrency ? `${price} ${priceCurrency.symbol}` : price;
  }
  return value || "N/A";
};
